import { render } from "./OpenaiIntegrationItem.vue?vue&type=template&id=0a8a004f&scoped=true"
import script from "./OpenaiIntegrationItem.vue?vue&type=script&lang=js"
export * from "./OpenaiIntegrationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8a004f"]])

export default __exports__